<template>
  <div class="text-xs p-2" :class="[level!==0 ? 'flex flex-wrap justify-between': '']">
    <div v-for="(value,key) of getCssStyles()" :key="key" class="flex flex-wrap items-center">
      <div
        class="p-1 w-36 flex items-center rounded-full hover:border-blue-600 hover:border"
        @click="addClass(value)"
      >
        <div
          v-if="!isObject(value)"
          class="w-4 h-4 mr-1 items-center border"
          :class="[applyClassOnBox(value)]"
        ></div>
        <div
          class="font-bold"
          v-if="!isNumber(key)"
        >{{key}}</div>
        <div v-if="!isObject(value)" :class="applyClassOnText(value)">{{value}}</div>
      </div>
      <div>
        <StylesManager
          class="pl-2"
          v-if="isObject(value) "
          :css="value"
          :level="level+1"
        />
      </div>
    </div>
    <!-- <div class="text-sm bg-gray-200 py-2">
      <div class="flex border-b border-gray-600">
        <div
          v-for="[key] of cssStyles"
          :key="key"
          class="px-2 font-bold flex-grow"
          :class="[key === tab ? 'bg-indigo-600 text-gray-100 rounded-t' : 'text-gray-600']"
          @click="selectTab(key)"
        >{{key}}</div>
      </div>
      <div v-for="[key,group] of cssStyles" :key="key" class="bg-gray-100">
        <div v-if="key === tab" class="flex w-full">
          <div v-for="[name, list] of getList(group)" :key="name">
            <div class="font-bold text-green-600 px-2">{{name}}</div>
            <div class="flex flex-wrap p-2">
              <div
                v-for="item of list"
                :key="item"
                class="hover:bg-blue-400 border border-gray-200 hover:text-black flex items-center px-1 w-24"
                :class="[isClassSelected(item) ? 'rounded-lg text-white font-bold bg-blue-600':'']"
                @click="addClass(item)"
              >
                <div>
                  <div :class="applyClassOnBox(item)" class="w-3 h-3 rounded-full border"></div>
                </div>
                <div class="m-auto text-xs p-1">
                  {{item}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "StylesManager",
  props: {
    css: null,
    level: { type: Number, default: 0 }
  },
  data() {
    return {
      list: ["w-2", "w-3"],
      tab: "Size",
      tabs: ["Size", "Flex", "Design", "Adjust"]
    };
  },
  mounted() {},
  computed: {
    ...mapGetters(["cssStyles"])
  },
  methods: {
    ...mapActions(["addClass"]),
    getCssStyles() {
      return this.css ? this.css : this.cssStyles;
    },
    isObject(obj) {
      return typeof obj === "object";
    },
    isString(obj) {
      return typeof obj === "string";
    },
    isNumber(obj) {
      return typeof obj === "number";
    },
    applyTabStyles() {
      if (this.level == 0) {
        return "text-blue-600";
      } else if (this.level == 1) {
        return "text-blue-500";
      } else {
        return "";
      }
    },
    applyClassOnBox(item) {
      if (item.includes("bg") || item.includes("shadow")) {
        return item;
      } else if (item.includes("text")) {
        return item.replace("text", "bg");
      } else if (item.includes("border")) {
        return "border" + " " + item;
      } else if(item.includes('rounded')) {
        return 'rounded-none '+item+' bg-red-600 ';
      } else {
        return "";
      }
    },
    applyClassOnText(item) {
      if (item.includes("font")) {
        return item;
      } else {
        return "";
      }
    },
    selectTab(tab) {
      this.tab = tab;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
